import { ShieldCheck, Users, type LucideIcon } from 'lucide-react';
import { ROLES_PORTAL_AGENTES, ROL_EMBAJADOR, ROL_INMOBILIARIA, etiquetaRol, type RolAsignado } from '@/lib/multiRol';
import { getPortalLoginUrl } from '@/lib/portalUrls';

export interface OpcionRol {
  key: string;
  label: string;
  description: string;
  icon: LucideIcon;
  rolId: number;
  route: string;
  /** false para Embajador (25): no cambia el rol activo, solo navega a su portal. */
  viaRpc: boolean;
  /**
   * `route` es una URL de otro host (agentes.sozu.com): se abre con
   * `window.location`, no con el router. La sesión no viaja entre hosts, así que
   * el usuario entra con su login ahí, y ese login activa su rol de agente.
   */
  externa?: boolean;
}

export const RUTA_PORTAL_EMBAJADOR = '/admin/portal-embajador/inicio';
export const RUTA_PORTAL_INMOBILIARIA = '/admin/portal-inmobiliaria/dashboard';

/** Destino al activar un rol desde admin.sozu.com (login o "Cambiar de rol"). */
export function rutaDeRol(rolId: number): string {
  if (rolId === ROL_EMBAJADOR) return RUTA_PORTAL_EMBAJADOR;
  if (rolId === ROL_INMOBILIARIA) return RUTA_PORTAL_INMOBILIARIA;
  // El portal de agentes dentro del admin (/admin/agent) está deprecado: los
  // agentes entran por su propio host.
  if (ROLES_PORTAL_AGENTES.includes(rolId)) return getPortalLoginUrl('agentes');
  return '/admin';
}

/** Opción del selector de rol a partir de un rol asignado en `user_roles`. */
export function opcionDeRol(rol: RolAsignado, rolActivo?: number | null): OpcionRol {
  const esEmbajador = rol.rol_id === ROL_EMBAJADOR;
  const esAgente = ROLES_PORTAL_AGENTES.includes(rol.rol_id);
  // Con contexto, la empresa ya va en el label ("Inmobiliaria · Sozu").
  const detalle = rol.es_principal ? 'Tu rol principal' : 'Rol adicional';
  return {
    key: `rol-${rol.rol_id}`,
    label: etiquetaRol(rol),
    description:
      rol.rol_id === rolActivo
        ? `${detalle} · rol actual`
        : esEmbajador
          ? `${detalle} · referidos y comisiones`
          : esAgente
            ? `${detalle} · se abre el portal de agentes`
            : detalle,
    icon: esEmbajador ? Users : ShieldCheck,
    rolId: rol.rol_id,
    route: rutaDeRol(rol.rol_id),
    // Agentes: no se cambia el rol activo del admin; lo activa el login de su host.
    viaRpc: !esEmbajador && !esAgente,
    externa: esAgente,
  };
}
